"use client";

import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function NewsletterSignup({ symbol }: { symbol?: string }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setStatus("loading");
    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, symbol }),
      });
      setStatus(res.ok ? "success" : "error");
    } catch {
      setStatus("error");
    }
  }

  if (status === "success") {
    return (
      <p className="text-center text-sm text-ink-secondary">
        Danke! Du bekommst bei neuen Funktionen Bescheid.
      </p>
    );
  }

  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <p className="font-serif text-lg font-semibold text-ink">Auf dem Laufenden bleiben</p>
      <p className="max-w-md text-sm text-muted-foreground">
        E-Mail-Adresse hinterlassen, um über neue Funktionen von Erikonomie
        informiert zu werden. Kein Tracking, jederzeit abbestellbar.
      </p>
      <form onSubmit={handleSubmit} className="flex w-full max-w-sm gap-2">
        <Input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="deine@email.de"
          aria-label="E-Mail-Adresse"
          className="bg-card"
        />
        <Button type="submit" disabled={status === "loading"} variant="secondary">
          Anmelden
        </Button>
      </form>
      {status === "error" && (
        <p className="text-xs text-negative">
          Anmeldung gerade nicht möglich. Bitte später erneut versuchen.
        </p>
      )}
    </div>
  );
}
